export default __webpack_public_path__ + "static/media/screen3.9287b46a.png";